export default "__VITE_ASSET__DvE_vL61__"